import { InjectionToken } from '@angular/core';
import { HttpServiceSettings } from '@cmx/shared/feature/platform-configuration';

export const HTTPSERVICESETTINGS = new InjectionToken<HttpServiceSettings>('http-service-settings');
export const APP_VERSION = new InjectionToken<string>('app-version');
export const HEADER_COLOR = new InjectionToken<string>('header-color');
